import React, { useEffect } from 'react';
import { Instagram } from 'lucide-react';
import GlitchText from '../GlitchText';
import '../../styles/pages/InstagramPage.css';
import { setViewportHeight } from '../../utils/viewport';

const InstagramPage = () => {
  // Enable scrolling for Instagram page
  useEffect(() => {
    // Update global flag to enable scrolling
    window.isHomePage = false;
    // Force scrolling to be enabled
    setViewportHeight(true);
  }, []);

  return (
    <div className="pt-1 min-h-screen background-pattern">
      <div className="container mx-auto px-4 py-16">
        {/* Inverted header box */}
        <div className="instagram-header-box animate-on-scroll">
          <h1 className="text-4xl font-black mb-2">
            <GlitchText 
              text="INSTAGRAM DOJO" 
              className="inline-block inverted-glitch" 
            />
          </h1>
          <p className="mb-0">FOLLOW OUR KIMCHI JOURNEY</p>
        </div>
        
        {/*
        <div className="text-center mb-10 animate-on-scroll">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-link"
          >
            <Instagram className="mr-2" size={24} />
            @mrwonskickass
          </a>
        </div>
        */}

        <script src="https://static.elfsight.com/platform/platform.js" async></script>
        <div class="elfsight-app-4089b2c3-c3a5-4f8e-8959-9d7ee76b9a39" data-elfsight-app-lazy></div>
        
        {/*}
        <div className="instagram-grid animate-on-scroll">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="instagram-item">
              <img src={`/api/placeholder/400/400`} alt={`Instagram post ${i}`} className="instagram-image" />
              <div className="instagram-overlay">
                <div className="instagram-likes">❤️ 123</div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center animate-on-scroll">
          <p className="text-gray-400">
            * Instagram feed integration coming soon
          </p>
        </div>
        */}
      </div>
    </div>
  );
};

export default InstagramPage; 